import React, { FormEvent } from "react";

interface MFACodeInputProps {
  error: { message: string } | null;
  isSubmitting: boolean;
  onSubmit: (e: FormEvent) => void;
}

export default class MFACodeInput extends React.Component<MFACodeInputProps> {
  render(): JSX.Element {
    return (
      <form autoComplete="off" onSubmit={this.props.onSubmit}>
        <div className="field-group mfa-setup-input mb-3">
          <label className="mb-0" htmlFor="otp-code">
            6-digit authenticator code
            <div className="mfa-setup-input__input-group">
              <input id="otp-code" name="otp_attempt" type="text" />

              {this.props.error && (
                <div className="field-error" data-testid="mfa-error">
                  <span className="field-error__highlight">
                    Invalid code entered:
                  </span>{" "}
                  {this.props.error.message}
                </div>
              )}
            </div>
          </label>
        </div>

        <div className="field-group">
          <button
            className="button is-primary"
            disabled={this.props.isSubmitting}
            type="submit"
          >
            Verify
          </button>
        </div>
      </form>
    );
  }
}
